var React = require('react');

function Alert (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m12 1a11 11 0 1 0 11 11 11.013 11.013 0 0 0 -11-11zm0 20a9 9 0 1 1 9-9 9.01 9.01 0 0 1 -9 9z","key":0}),React.createElement("path",{"d":"m12 5a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-8a1 1 0 0 0 -1-1z","key":1}),React.createElement("circle",{"cx":"12","cy":"17","r":"1","key":2})]);
}

Alert.defaultProps = {"id":"Layer_2","height":"512","viewBox":"0 0 24 24","width":"512","data-name":"Layer 2"};

module.exports = Alert;

Alert.default = Alert;
